import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { matchingLabel, matchingLabelText } from "./styles_vanilla.css";
import { getTaxIdLabel } from "./utils";

export const TaxIdMatchingLabel = ({ taxIdType }: { taxIdType?: string | null }) => (
  <Flex flexDirection="row" alignItems="center" gap={4} className={matchingLabel}>
    <Icon type="info-circle" variant="solid" size="small" color={Colors.Informative600} />
    <Text asSpan variant="regular-sm" className={matchingLabelText}>
      Existing profile found for this {getTaxIdLabel(taxIdType)}
    </Text>
  </Flex>
);
